import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconModule } from '@coreui/icons-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { HasAccessModule } from 'src/app/@core/directives/has-access/has-access.module';
import { HasPrivilegeModule } from 'src/app/@core/directives/has-privilege/has-privilege.module';
import { PosCreditInstallmentsModule } from 'src/app/shared/pos-credit-installments/pos-credit-installments.module';
import { PosListModule } from 'src/app/shared/pos-list/pos-list.module';
import { PosPaymentMethodModule } from 'src/app/shared/pos-payment-method/pos-payment-method.module';
import { PosPrintDocumentsModalModule } from 'src/app/shared/pos-print-documents-modal/pos-print-documents-modal.module';
import { PosProductListComponent } from 'src/app/shared/pos-product-list/pos-product-list.component';
import { PosStepperModule } from 'src/app/shared/pos-stepper/pos-stepper.module';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';
import { PosCustomerTableModalModule } from './../../shared/pos-customer-table-modal/pos-customer-table-modal.module';
import { PosCustomerTableModule } from './../../shared/pos-customer-table/pos-customer-table.module';
import { PosNoEnterCreditRequestReasonModalModule } from './../../shared/pos-no-enter-credit-request-reason-modal/pos-no-enter-credit-request-reason-modal.module';
import * as fromComponents from './components';
import { AdvanceComponent } from './components/advance/advance.component';
import { CustomerAdvancesComponent } from './components/customer-advances/customer-advances.component';
import { CustomerLoansDetailComponent } from './components/customer-loans-detail/customer-loans-detail.component';
import { CustomerPreApprovalModalIncomeFormComponent } from './components/customer-pre-approval-modal-income-form/customer-pre-approval-modal-income-form.component';
import { CustomersRoutingModule } from './customers-routing.module';

import { NgxMaskModule } from 'ngx-mask';
import { PosPsychometricEvaluationModalModule } from 'src/app/shared/pos-psychometric-evaluation-modal/pos-psychometric-evaluation-modal.module';
import { InvoiceDetailsStepModule } from "../invoices/invoice-stepper/invoice-details-step/invoice-details-step.module";
import { PayInvoiceStepModule } from "../invoices/invoice-stepper/pay-invoice-step/pay-invoice-step.module";
import { ReturnContractStepModule } from '../return-invoices/create-credit-return-invoice-stepper/return-contract-step/return-contract-step.module';
import { AdvanceCreateStepComponent } from './components/customer-advances/advance-create/advance-create-step/advance-create-step.component';


@NgModule({
  declarations: [
    ...fromComponents.components,
    AdvanceComponent,
    CustomerAdvancesComponent,
    PosProductListComponent,
    CustomerLoansDetailComponent,
    CustomerPreApprovalModalIncomeFormComponent,
    AdvanceCreateStepComponent,
  ],
  imports: [
    CommonModule,
    CustomersRoutingModule,
    PosCustomerTableModule,
    AccordionModule.forRoot(),
    ReactiveFormsModule,
    PosCustomerTableModalModule,
    PosStepperModule,
    CdkStepperModule,
    IconModule,
    NgSelectModule,
    PosCreditInstallmentsModule,
    PosTableModule,
    PopoverModule.forRoot(),
    BsDatepickerModule.forRoot(),
    PosPaymentMethodModule,
    HasPrivilegeModule,
    HasAccessModule,
    PosListModule,
    TabsModule,
    PosNoEnterCreditRequestReasonModalModule,
    PosPrintDocumentsModalModule,
    PosPsychometricEvaluationModalModule,
    ReturnContractStepModule,
    FormsModule,
    PayInvoiceStepModule,
    InvoiceDetailsStepModule,
    PosStepperModule,
    CdkStepperModule,
    PosPaymentMethodModule,
    NgxMaskModule,
    HasPrivilegeModule
  ],
  exports: [...fromComponents.components],
  providers: [],
})
export class CustomersModule { }
